module.exports = __webpack_public_path__ + "img/headerbg.086de53f.png";